export default {
  namespaced: true,
  state: {
    item: null
  },
  getters: {
    client: state => state.item
  },
  mutations: {
    setClient (state, client) {
      state.item = client
    }
  }
}
